// INTEGRATED-VARIANT-SUMMARY.JS - FIXED VERSION WITH PROPER PRICE UPDATES
class IntegratedVariantSummary {
  constructor() {
    this.variantPicker = document.querySelector('variant-picker');
    this.productData = null;
    this.productForm = null;
    this.selectedVariantId = null;
    this.hasMultipleVariants = false;
    this.init();
  }

  init() {
    if (!this.variantPicker) return;

    const scriptTag = this.variantPicker.querySelector('script[type="application/json"]');
    if (scriptTag) {
      this.productData = JSON.parse(scriptTag.textContent);
    }

    if (!this.productData) return;

    const product = this.productData.product;
    if (!product.variants || product.variants.length <= 1) {
      console.log('Product has no variants or only one variant. Skipping custom variant selector.');
      return;
    }

    const hasOption1 = product.variants.some(v => v.option1);
    if (!hasOption1) {
      console.log('Product does not use option1. Skipping custom variant selector.');
      return;
    }

    // Check if product uses option3 (state delivery question)
    this.hasOption3 = product.variants.some(v => v.option3 && v.option3 !== '-' && v.option3 !== '');
    console.log('Product uses option3 (state delivery):', this.hasOption3);

    this.hasMultipleVariants = true;
    this.productForm = document.querySelector('form[action*="/cart/add"]');
    this.variantPicker.style.display = 'none';

    this.createIntegratedSummary();
    this.setupEventListeners();
    this.protectVariantInput();
    this.updateSummary();
  }

  createIntegratedSummary() {
    const product = this.productData.product;
    
    const deliveryMethods = this.getUniqueOptionValues(0);
    const locations = this.getUniqueOptionValues(1);
    const stateOptions = this.getUniqueOptionValues(2);

    const basePrice = this.getBasePrice();
    const defaultPrice = this.formatMoney(basePrice);

    const summaryHTML = `
      <div class="integrated-variant-summary">
        <h4>Configure Your Order</h4>
        
        <div class="summary-content">
          <!-- Variant Selectors Section -->
          <div class="variant-selectors-section">
            <div class="selector-group">
              <label for="delivery-method-select" class="selector-label required">
                <span>Delivery Method</span>
              </label>
              <select id="delivery-method-select" class="variant-dropdown">
                <option value="">Choose a delivery method</option>
                ${deliveryMethods.map(method => `
                  <option value="${this.escapeHtml(method)}">${this.escapeHtml(method)}</option>
                `).join('')}
              </select>
            </div>

            <div class="selector-group" id="location-selector-group" style="display: none;">
              <label for="location-select" class="selector-label required">
                <span>Warehouse Location</span>
              </label>
              <select id="location-select" class="variant-dropdown">
                <option value="">Select a warehouse</option>
                ${locations.filter(loc => loc !== '-').map(location => `
                  <option value="${this.escapeHtml(location)}">${this.escapeHtml(location)}</option>
                `).join('')}
              </select>
            </div>

            ${this.hasOption3 ? `
            <div class="selector-group" id="state-selector-group" style="display: none;">
              <label for="state-select" class="selector-label required">
                <span>Being Delivered to CA, OR, WA, MT, WY, ND, SD, or NY?</span>
              </label>
              <select id="state-select" class="variant-dropdown">
                <option value="">Select an option</option>
                ${stateOptions.filter(opt => opt !== '-').map(option => `
                  <option value="${this.escapeHtml(option)}">${this.escapeHtml(option)}</option>
                `).join('')}
              </select>
            </div>
            ` : ''}
          </div>

          <!-- Price Summary Section -->
          <div class="price-summary-section">
            <div class="summary-items">
              <div class="summary-item">
                <span class="item-label">Base Price:</span>
                <span class="item-value" id="base-price-display">${defaultPrice}</span>
              </div>
              <div class="summary-item" id="shipping-cost-row" style="display: none;">
                <span class="item-label">Shipping & Handling Cost:</span>
                <span class="item-value" id="shipping-cost-display">$0.00</span>
              </div>
              <div class="summary-item" id="selected-location-row" style="display: none;">
                <span class="item-label">Pickup Location:</span>
                <span class="item-value" id="selected-location-display">-</span>
              </div>
              <div class="summary-item" id="state-fee-row" style="display: none;">
                <span class="item-label">State Delivery Fee:</span>
                <span class="item-value" id="state-fee-display">$0.00</span>
              </div>
            </div>
            <div class="summary-total">
              <span class="total-label">Total Price:</span>
              <span class="total-value" id="total-price-display">${defaultPrice}</span>
            </div>
          </div>
        </div>

        <div class="error-message" id="variant-error" style="display: none;">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8 1.5C4.41 1.5 1.5 4.41 1.5 8C1.5 11.59 4.41 14.5 8 14.5C11.59 14.5 14.5 11.59 14.5 8C14.5 4.41 11.59 1.5 8 1.5ZM8 10C7.45 10 7 9.55 7 9V8C7 7.45 7.45 7 8 7C8.55 7 9 7.45 9 8V9C9 9.55 8.55 10 8 10ZM9 6H7V4H9V6Z" fill="currentColor"/>
          </svg>
          <span id="variant-error-text">Please select all required options</span>
        </div>
      </div>
    `;

    this.variantPicker.insertAdjacentHTML('beforebegin', summaryHTML);
  }

  protectVariantInput() {
    const variantInput = document.querySelector('input[name="id"]');
    if (!variantInput) return;

    const observer = new MutationObserver(() => {
      if (this.selectedVariantId && variantInput.value != this.selectedVariantId) {
        console.warn('Variant input was changed externally! Restoring correct variant:', this.selectedVariantId);
        variantInput.value = this.selectedVariantId;
      }
    });

    observer.observe(variantInput, {
      attributes: true,
      attributeFilter: ['value']
    });

    setInterval(() => {
      if (this.selectedVariantId && variantInput.value != this.selectedVariantId) {
        console.warn('Variant input was changed! Restoring:', this.selectedVariantId);
        variantInput.value = this.selectedVariantId;
      }
    }, 100);
  }

  escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  getUniqueOptionValues(optionIndex) {
    const product = this.productData.product;
    const values = new Set();
    
    product.variants.forEach(variant => {
      const optionValue = variant[`option${optionIndex + 1}`];
      if (optionValue) {
        values.add(optionValue);
      }
    });
    
    return Array.from(values);
  }

  setupEventListeners() {
    const deliverySelect = document.getElementById('delivery-method-select');
    const locationSelect = document.getElementById('location-select');
    const stateSelect = document.getElementById('state-select');

    if (deliverySelect) {
      deliverySelect.addEventListener('change', () => {
        this.handleDeliveryMethodChange();
        this.updateSummary();
      });
    }

    if (locationSelect) {
      locationSelect.addEventListener('change', () => {
        this.updateSummary();
      });
    }

    if (stateSelect) {
      stateSelect.addEventListener('change', () => {
        this.updateSummary();
      });
    }
  }

  handleDeliveryMethodChange() {
    const deliverySelect = document.getElementById('delivery-method-select');
    const locationGroup = document.getElementById('location-selector-group');
    const locationSelect = document.getElementById('location-select');
    const stateGroup = document.getElementById('state-selector-group');
    const stateSelect = document.getElementById('state-select');
    
    const deliveryMethod = deliverySelect.value;

    const isPickup = deliveryMethod.toLowerCase().includes('pickup') || 
                     deliveryMethod.toLowerCase().includes('warehouse');
    
    const isShipping = deliveryMethod.toLowerCase().includes('shipping') || 
                       deliveryMethod.toLowerCase().includes('delivery') ||
                       deliveryMethod.toLowerCase().includes('residence') ||
                       deliveryMethod.toLowerCase().includes('business');

    if (isPickup) {
      locationGroup.style.display = 'block';
      if (stateGroup) stateGroup.style.display = 'none';
      locationSelect.value = '';
      if (stateSelect) stateSelect.value = '';
    } else if (isShipping && this.hasOption3) {
      locationGroup.style.display = 'none';
      if (stateGroup) stateGroup.style.display = 'block';
      locationSelect.value = '';
      if (stateSelect) stateSelect.value = '';
    } else if (isShipping && !this.hasOption3) {
      locationGroup.style.display = 'none';
      locationSelect.value = '';
    } else {
      locationGroup.style.display = 'none';
      if (stateGroup) stateGroup.style.display = 'none';
      locationSelect.value = '';
      if (stateSelect) stateSelect.value = '';
    }
  }

  updateSummary() {
    const deliverySelect = document.getElementById('delivery-method-select');
    const locationSelect = document.getElementById('location-select');
    const stateSelect = document.getElementById('state-select');
    
    const deliveryMethod = deliverySelect?.value || '';
    let location = locationSelect?.value || '';
    let stateOption = stateSelect?.value || '';

    const isPickup = deliveryMethod.toLowerCase().includes('pickup') || 
                     deliveryMethod.toLowerCase().includes('warehouse');
    
    const isShipping = deliveryMethod.toLowerCase().includes('shipping') || 
                       deliveryMethod.toLowerCase().includes('delivery') ||
                       deliveryMethod.toLowerCase().includes('residence') ||
                       deliveryMethod.toLowerCase().includes('business');

    // Auto-set the unused options to "-"
    if (isPickup && deliveryMethod) {
      stateOption = '-';
      console.log('Auto-selected state option "-" for pickup method');
    } else if (isShipping && deliveryMethod && this.hasOption3 && stateOption) {
      location = '-';
      console.log('Auto-selected location "-" for shipping method with option3');
    } else if (isShipping && deliveryMethod && !this.hasOption3) {
      location = '-';
      stateOption = '-';
      console.log('Auto-selected location and state to "-" for shipping method without option3');
    }

    console.log('Update Summary - Delivery:', deliveryMethod, 'Location:', location, 'State:', stateOption);

    const variant = this.findMatchingVariant(deliveryMethod, location, stateOption);

    console.log('Found variant:', variant);

    if (!variant) {
      this.showDefaultPrices();
      this.selectedVariantId = null;
      this.clearShopifyVariantInput();
      this.disableAddToCart();
      return;
    }

    this.selectedVariantId = variant.id;
    this.selectShopifyVariant(variant);
    this.enableAddToCart();

    const basePrice = this.getBasePrice();
    const currentPrice = variant.price / 100;
    const additionalCost = Math.max(0, currentPrice - basePrice);

    document.getElementById('base-price-display').textContent = this.formatMoney(basePrice);
    document.getElementById('total-price-display').textContent = this.formatMoney(currentPrice);

    const shippingRow = document.getElementById('shipping-cost-row');
    const stateFeeRow = document.getElementById('state-fee-row');
    
    if (isShipping && additionalCost > 0) {
      shippingRow.style.display = 'flex';
      document.getElementById('shipping-cost-display').textContent = this.formatMoney(additionalCost);
      stateFeeRow.style.display = 'none';
    } else {
      shippingRow.style.display = 'none';
      stateFeeRow.style.display = 'none';
    }

    const locationRow = document.getElementById('selected-location-row');
    if (isPickup && location && location !== '-') {
      locationRow.style.display = 'flex';
      document.getElementById('selected-location-display').textContent = location;
    } else {
      locationRow.style.display = 'none';
    }

    this.hideError();
  }

  findMatchingVariant(deliveryMethod, location, stateOption) {
    if (!this.productData || !deliveryMethod) return null;

    const product = this.productData.product;

    console.log('Finding variant for:', { deliveryMethod, location, stateOption, hasOption3: this.hasOption3 });

    const isPickup = deliveryMethod.toLowerCase().includes('pickup') || 
                     deliveryMethod.toLowerCase().includes('warehouse');

    if (isPickup) {
      if (!location || location === '-') {
        console.log('Pickup requires location');
        return null;
      }

      const match = product.variants.find(v => {
        const option1Match = v.option1 === deliveryMethod;
        const option2Match = v.option2 === location;
        const option3Match = v.option3 === '-' || !v.option3 || v.option3 === '';
        console.log('Checking pickup variant:', v.id, 'o1:', option1Match, 'o2:', option2Match, 'o3:', option3Match);
        return option1Match && option2Match && option3Match;
      });

      console.log('Pickup match:', match);
      return match || null;
    }

    // For shipping/delivery
    if (this.hasOption3) {
      if (!stateOption) {
        console.log('❌ Shipping with option3 requires state selection (stateOption is empty)');
        return null;
      }

      console.log('🔍 SEARCHING FOR SHIPPING VARIANT:');
      console.log('  Looking for: option1="' + deliveryMethod + '", option2="-", option3="' + stateOption + '"');
      
      const match = product.variants.find(v => {
        const option1Match = v.option1 === deliveryMethod;
        const option2Match = v.option2 === '-' || !v.option2 || v.option2 === '';
        const option3Match = v.option3 === stateOption;
        
        if (option1Match || option3Match) {
          console.log('  Checking variant ID ' + v.id + ':');
          console.log('    option1: "' + v.option1 + '" === "' + deliveryMethod + '" ? ' + option1Match);
          console.log('    option2: "' + v.option2 + '" === "-" ? ' + option2Match);
          console.log('    option3: "' + v.option3 + '" === "' + stateOption + '" ? ' + option3Match);
          console.log('    MATCH: ' + (option1Match && option2Match && option3Match));
        }
        
        return option1Match && option2Match && option3Match;
      });

      if (match) {
        console.log('✅ Found shipping variant:', match.id);
      } else {
        console.log('❌ No shipping variant found!');
      }
      
      return match || null;
    } else {
      const match = product.variants.find(v => {
        const option1Match = v.option1 === deliveryMethod;
        const option2Match = v.option2 === '-' || !v.option2 || v.option2 === '';
        console.log('Checking shipping variant (no option3):', v.id, 'o1:', option1Match, 'o2:', option2Match,
                    'actual values - o1:', v.option1, 'o2:', v.option2);
        return option1Match && option2Match;
      });

      console.log('Shipping match (no option3):', match);
      return match || null;
    }
  }

  selectShopifyVariant(variant) {
    console.log('🔵 Selecting Shopify variant:', variant.id, variant.option1, variant.option2, variant.option3);

    // STEP 1: Update radio buttons FIRST
    this.updateHiddenRadioButtons(variant);

    // STEP 2: Update variant input
    const variantInput = document.querySelector('input[name="id"]');
    if (variantInput) {
      const oldValue = variantInput.value;
      variantInput.value = variant.id;
      variantInput.setAttribute('value', variant.id);
      console.log('Updated variant input from', oldValue, 'to', variant.id);
    }

    // STEP 3: Update line item properties
    this.updateLineItemProperties(variant);

    // STEP 4: CRITICAL - Force the theme's variant-picker to process the change
    // This will trigger updatePrice() and all other theme methods
    this.triggerThemeVariantChange(variant);

    // STEP 5: Update URL if needed
    if (this.variantPicker && this.variantPicker.dataset.updateUrl === 'true') {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    }

    console.log('✅ Variant selection complete');
  }

  /**
   * CRITICAL FIX: Force the theme's variant-picker to fully process the variant change
   * This ensures updatePrice() and all theme methods run properly
   */
  triggerThemeVariantChange(variant) {
    console.log('🔧 Triggering theme variant change handler...');
    
    // CRITICAL: Update the theme's internal variant and selectedOptions state FIRST
    // This is what handleVariantChange normally does, and updatePrice() depends on it
    if (this.variantPicker) {
      console.log('📝 Updating theme internal state: variant and selectedOptions');
      
      // Store old values for debugging
      const oldVariant = this.variantPicker.variant;
      const oldPreSelection = this.variantPicker.preSelection;
      
      // Update the internal state
      this.variantPicker.variant = variant;
      this.variantPicker.selectedOptions = variant.options;
      this.variantPicker.preSelection = false; // Indicate a variant is selected
      
      console.log('Theme state changed from:', {
        oldVariant: oldVariant?.id,
        oldPreSelection: oldPreSelection
      });
      console.log('Theme state updated to:', {
        variant: this.variantPicker.variant?.id,
        preSelection: this.variantPicker.preSelection,
        selectedOptions: this.variantPicker.selectedOptions
      });
      
      // Verify the state was actually set
      console.log('Verification - this.variantPicker.variant:', this.variantPicker.variant?.id);
      console.log('Verification - this.variantPicker.preSelection:', this.variantPicker.preSelection);
    }
    
    // Find a checked radio button to use as the event target
    const checkedRadio = this.variantPicker.querySelector('input[type="radio"]:checked');
    
    // Create a proper event object with a target
    const changeEvent = new Event('change', { bubbles: true });
    
    if (checkedRadio) {
      Object.defineProperty(changeEvent, 'target', {
        writable: false,
        value: checkedRadio
      });
    }
    
    // Dispatch the event on the variant-picker
    this.variantPicker.dispatchEvent(changeEvent);
    
    // Force call updatePrice
    if (this.variantPicker.updatePrice) {
      console.log('🔄 Force calling updatePrice (variant state is now set)');
      this.variantPicker.updatePrice();
      
      // Check if price was updated
      setTimeout(() => {
        const priceDefault = document.querySelector('.price__default');
        const priceNoVariant = document.querySelector('.price__no-variant');
        
        console.log('After updatePrice - price__default hidden?', priceDefault?.hidden);
        console.log('After updatePrice - price__no-variant hidden?', priceNoVariant?.hidden);
        
        // FALLBACK: If the theme's method didn't work, manually fix it
        if (priceDefault && priceDefault.hidden) {
          console.warn('⚠️ Theme updatePrice failed! Manually fixing price display...');
          
          // Update the actual price values from the variant data
          const variantData = this.productData.formatted[variant.id];
          
          if (variantData) {
            console.log('Variant data:', variantData);
            
            // Update current price
            const priceCurrentEl = priceDefault.querySelector('.price__current');
            if (priceCurrentEl) {
              priceCurrentEl.innerHTML = variantData.price;
              console.log('Updated price__current to:', variantData.price);
            }
            
            // Update compare at price (sale price)
            const priceWasEl = priceDefault.querySelector('.price__was');
            if (priceWasEl && variantData.compareAtPrice) {
              priceWasEl.innerHTML = variantData.compareAtPrice;
              priceWasEl.hidden = false;
              console.log('Updated price__was to:', variantData.compareAtPrice);
            } else if (priceWasEl) {
              priceWasEl.hidden = true;
            }
            
            // Update the price container classes
            const priceContainer = document.querySelector('.product-info__price > .price');
            if (priceContainer) {
              priceContainer.classList.toggle('price--on-sale', variant.compare_at_price > variant.price);
              priceContainer.classList.toggle('price--sold-out', !variant.available);
              console.log('Updated price container classes');
            }
          }
          
          // Show/hide the right elements
          priceDefault.hidden = false;
          if (priceNoVariant) {
            priceNoVariant.hidden = true;
          }
          
          console.log('✅ Manually corrected price display with updated values');
        }
      }, 50);
    }
    
    // Call other methods
    if (this.variantPicker.updateAvailability) {
      console.log('Calling updateAvailability');
      this.variantPicker.updateAvailability();
    }
    
    if (this.variantPicker.updateAddToCartButton) {
      console.log('Calling updateAddToCartButton');
      this.variantPicker.updateAddToCartButton();
    }
    
    // Dispatch custom event
    document.dispatchEvent(new CustomEvent('variant:change', {
      detail: { 
        variant: variant,
        variantId: variant.id
      }
    }));
    
    console.log('✅ Theme variant change triggered');
  }

  updateLineItemProperties(variant) {
    const productForm = document.querySelector('form[action*="/cart/add"]');
    if (!productForm) {
      console.error('Could not find product form!');
      return;
    }

    // Remove any existing property inputs first
    const existingProperties = productForm.querySelectorAll('input[name^="properties["]');
    existingProperties.forEach(input => {
      console.log('Removing existing property:', input.name);
      input.remove();
    });

    const isPickup = variant.option1 && (
      variant.option1.includes('Warehouse Pickup') || 
      variant.option1.toLowerCase().includes('pickup')
    );

    const properties = {
      'Delivery Method': variant.option1 || '',
      '_delivery_type': isPickup ? 'pickup' : 'shipping'
    };

    if (isPickup && variant.option2 && variant.option2 !== '-') {
      properties['Pickup Location'] = variant.option2;
    }

    if (!isPickup && variant.option3 && variant.option3 !== '-') {
      properties['State Delivery'] = variant.option3;
    }

    Object.keys(properties).forEach(key => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = `properties[${key}]`;
      input.value = properties[key];
      input.setAttribute('data-variant-property', 'true');
      productForm.appendChild(input);
      console.log(`Added input: properties[${key}] = ${properties[key]}`);
    });

    console.log('✅ Added line item properties:', properties);
  }

  updateHiddenRadioButtons(variant) {
    console.log('🔘 Updating radio buttons for variant:', variant.id);
    console.log('Target options:', variant.option1, variant.option2, variant.option3);
    
    // Get all option selectors in order (they correspond to option1, option2, option3)
    const optionSelectors = Array.from(this.variantPicker.querySelectorAll('.option-selector'));
    
    console.log('Found', optionSelectors.length, 'option selectors');
    
    // Process each option selector
    optionSelectors.forEach((selector, selectorIndex) => {
      const optionNumber = selectorIndex + 1; // 1, 2, or 3
      const targetValue = variant[`option${optionNumber}`];
      
      if (!targetValue) {
        console.log(`Skipping option${optionNumber} - no value in variant`);
        return;
      }
      
      console.log(`Processing option${optionNumber}, target value: "${targetValue}"`);
      
      // Get all radios within THIS selector only
      const radios = selector.querySelectorAll('input[type="radio"]');
      
      radios.forEach(radio => {
        const label = radio.nextElementSibling?.textContent.trim();
        const shouldCheck = label === targetValue;
        
        if (shouldCheck && !radio.checked) {
          radio.checked = true;
          console.log(`✓ Checked radio for option${optionNumber}: "${label}"`);
          
          // Dispatch change event
          const changeEvent = new Event('change', { bubbles: true });
          radio.dispatchEvent(changeEvent);
        } else if (!shouldCheck && radio.checked) {
          // Uncheck if it was checked but shouldn't be
          radio.checked = false;
          console.log(`✗ Unchecked radio for option${optionNumber}: "${label}"`);
        }
      });
    });
    
    // Verify the selections
    console.log('🔍 Verification - checking what\'s actually selected now:');
    const checkedRadios = this.variantPicker.querySelectorAll('input[type="radio"]:checked');
    checkedRadios.forEach(radio => {
      const label = radio.nextElementSibling?.textContent.trim();
      const fieldset = radio.closest('fieldset');
      const legend = fieldset?.querySelector('legend')?.textContent.trim();
      console.log(`  ✓ "${label}" (${legend})`);
    });
  }

  clearShopifyVariantInput() {
    const variantInput = document.querySelector('input[name="id"]');
    if (variantInput) {
      variantInput.value = '';
      variantInput.removeAttribute('value');
    }
  }

  enableAddToCart() {
    const addToCartBtn = document.querySelector('button[name="add"]');
    if (addToCartBtn) {
      addToCartBtn.disabled = false;
      addToCartBtn.textContent = addToCartBtn.dataset.addToCartText || 'Add to cart';
      console.log('Enabled add to cart button');
    }
  }

  disableAddToCart() {
    const addToCartBtn = document.querySelector('button[name="add"]');
    if (addToCartBtn) {
      addToCartBtn.disabled = true;
      addToCartBtn.textContent = 'Make a selection';
      console.log('Disabled add to cart button');
    }
  }

  showDefaultPrices() {
    const basePrice = this.getBasePrice();
    document.getElementById('base-price-display').textContent = this.formatMoney(basePrice);
    document.getElementById('total-price-display').textContent = this.formatMoney(basePrice);
    document.getElementById('shipping-cost-row').style.display = 'none';
    document.getElementById('selected-location-row').style.display = 'none';
    document.getElementById('state-fee-row').style.display = 'none';
  }

  getBasePrice() {
    if (!this.productData || !this.productData.product) return 0;
    
    const product = this.productData.product;
    const warehouseVariants = product.variants.filter(v => 
      v.option1 && v.option1.includes('Warehouse Pickup')
    );

    if (warehouseVariants.length === 0) return product.price_min / 100;

    return Math.min(...warehouseVariants.map(v => v.price)) / 100;
  }

  showError(message) {
    const errorEl = document.getElementById('variant-error');
    const errorText = document.getElementById('variant-error-text');
    if (errorEl && errorText) {
      errorText.textContent = message;
      errorEl.style.display = 'flex';
    }
  }

  hideError() {
    const errorEl = document.getElementById('variant-error');
    if (errorEl) {
      errorEl.style.display = 'none';
    }
  }

  formatMoney(amount) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(amount);
  }
}

// Enhanced validation
function setupAddToCartValidation() {
  const customVariantSummary = document.querySelector('.integrated-variant-summary');
  if (!customVariantSummary) {
    console.log('No custom variant selector found. Skipping custom validation.');
    return;
  }

  const addToCartBtn = document.querySelector('button[name="add"], .product-form__submit, #add-to-cart-btn');
  
  if (!addToCartBtn) return;

  // Intercept fetch requests
  const originalFetch = window.fetch;
  window.fetch = function(...args) {
    const [url, options] = args;
    
    if (url && url.includes('/cart/add')) {
      console.log('🔍 Intercepted cart/add request');
      
      if (options && options.method === 'POST' && options.body) {
        try {
          let bodyData;
          
          if (typeof options.body === 'string') {
            bodyData = JSON.parse(options.body);
          } else if (options.body instanceof FormData) {
            bodyData = {};
            for (let [key, value] of options.body.entries()) {
              bodyData[key] = value;
            }
          } else {
            bodyData = options.body;
          }
          
          if (!bodyData.properties || Object.keys(bodyData.properties).length === 0) {
            const deliverySelect = document.getElementById('delivery-method-select');
            const locationSelect = document.getElementById('location-select');
            const stateSelect = document.getElementById('state-select');
            
            if (deliverySelect && deliverySelect.value) {
              const isPickup = deliverySelect.value.toLowerCase().includes('pickup');
              
              bodyData.properties = {
                'Delivery Method': deliverySelect.value,
                '_delivery_type': isPickup ? 'pickup' : 'shipping'
              };
              
              if (isPickup && locationSelect && locationSelect.value) {
                bodyData.properties['Pickup Location'] = locationSelect.value;
              } else if (!isPickup && stateSelect && stateSelect.value) {
                bodyData.properties['State Delivery'] = stateSelect.value;
              }
              
              console.log('✅ Injected properties into Ajax cart add:', bodyData.properties);
            }
          }
          
          options.body = JSON.stringify(bodyData);
          options.headers = options.headers || {};
          options.headers['Content-Type'] = 'application/json';
          
        } catch (e) {
          console.error('Error modifying cart add request:', e);
        }
      }
    }
    
    return originalFetch.apply(this, args);
  };

  // Intercept XMLHttpRequest
  const originalXHROpen = XMLHttpRequest.prototype.open;
  const originalXHRSend = XMLHttpRequest.prototype.send;
  
  XMLHttpRequest.prototype.open = function(method, url) {
    this._url = url;
    this._method = method;
    return originalXHROpen.apply(this, arguments);
  };
  
  XMLHttpRequest.prototype.send = function(body) {
    if (this._url && this._url.includes('/cart/add') && this._method === 'POST') {
      console.log('🔍 Intercepted XHR cart/add request');
      
      try {
        let bodyData = typeof body === 'string' ? JSON.parse(body) : body;
        
        if (!bodyData.properties || Object.keys(bodyData.properties).length === 0) {
          const deliverySelect = document.getElementById('delivery-method-select');
          const locationSelect = document.getElementById('location-select');
          const stateSelect = document.getElementById('state-select');
          
          if (deliverySelect && deliverySelect.value) {
            const isPickup = deliverySelect.value.toLowerCase().includes('pickup');
            
            bodyData.properties = {
              'Delivery Method': deliverySelect.value,
              '_delivery_type': isPickup ? 'pickup' : 'shipping'
            };
            
            if (isPickup && locationSelect && locationSelect.value) {
              bodyData.properties['Pickup Location'] = locationSelect.value;
            } else if (!isPickup && stateSelect && stateSelect.value) {
              bodyData.properties['State Delivery'] = stateSelect.value;
            }
            
            console.log('✅ Injected properties into XHR cart add:', bodyData.properties);
          }
          
          body = JSON.stringify(bodyData);
        }
      } catch (e) {
        console.error('Error modifying XHR request:', e);
      }
    }
    
    return originalXHRSend.call(this, body);
  };

  addToCartBtn.addEventListener('click', (e) => {
    const deliverySelect = document.getElementById('delivery-method-select');
    const locationSelect = document.getElementById('location-select');
    const stateSelect = document.getElementById('state-select');
    const locationGroup = document.getElementById('location-selector-group');
    const stateGroup = document.getElementById('state-selector-group');
    
    console.log('Add to cart validation - Delivery:', deliverySelect?.value, 'Location:', locationSelect?.value, 'State:', stateSelect?.value);
    
    if (!deliverySelect || !deliverySelect.value) {
      e.preventDefault();
      e.stopImmediatePropagation();
      
      const summary = document.querySelector('.integrated-variant-summary');
      if (summary) {
        summary.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      
      if (window.variantSummary) {
        window.variantSummary.showError('Please select a delivery method');
      }
      
      deliverySelect?.focus();
      return false;
    }

    const isLocationVisible = locationGroup && locationGroup.style.display !== 'none';
    if (isLocationVisible && (!locationSelect || !locationSelect.value)) {
      e.preventDefault();
      e.stopImmediatePropagation();
      
      const summary = document.querySelector('.integrated-variant-summary');
      if (summary) {
        summary.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      
      if (window.variantSummary) {
        window.variantSummary.showError('Please select a warehouse location');
      }
      
      locationSelect?.focus();
      return false;
    }

    const isStateVisible = stateGroup && stateGroup.style.display !== 'none';
    if (isStateVisible && (!stateSelect || !stateSelect.value)) {
      e.preventDefault();
      e.stopImmediatePropagation();
      
      const summary = document.querySelector('.integrated-variant-summary');
      if (summary) {
        summary.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      
      if (window.variantSummary) {
        window.variantSummary.showError('Please select whether you are in CA, OR, WA, MT, WY, ND, SD, or NY');
      }
      
      stateSelect?.focus();
      return false;
    }

    if (window.variantSummary && window.variantSummary.selectedVariantId) {
      const variantInput = document.querySelector('input[name="id"]');
      if (variantInput) {
        variantInput.value = window.variantSummary.selectedVariantId;
        variantInput.setAttribute('value', window.variantSummary.selectedVariantId);
        console.log('Force set variant input to:', window.variantSummary.selectedVariantId);
      }
    }

    const variantInput = document.querySelector('input[name="id"]');
    console.log('Final variant input value:', variantInput?.value);
    
    if (!variantInput || !variantInput.value) {
      e.preventDefault();
      e.stopImmediatePropagation();
      
      if (window.variantSummary) {
        window.variantSummary.showError('Please complete your selection');
      }
      
      return false;
    }
  }, true);
  
  const productForm = document.querySelector('form[action*="/cart/add"]');
  if (productForm) {
    productForm.addEventListener('submit', (e) => {
      console.log('Form submitting - checking for properties...');
      
      if (window.variantSummary && window.variantSummary.selectedVariantId) {
        const variantInput = document.querySelector('input[name="id"]');
        if (variantInput) {
          variantInput.value = window.variantSummary.selectedVariantId;
          variantInput.setAttribute('value', window.variantSummary.selectedVariantId);
          console.log('Form submit - Force set variant to:', window.variantSummary.selectedVariantId);
        }
        
        const formData = new FormData(productForm);
        let hasProperties = false;
        console.log('Properties in form at submit:');
        for (let [key, value] of formData.entries()) {
          if (key.startsWith('properties[')) {
            console.log(`  ${key} = ${value}`);
            hasProperties = true;
          }
        }
        
        if (!hasProperties) {
          console.error('❌ NO PROPERTIES FOUND IN FORM! Re-adding...');
          const deliverySelect = document.getElementById('delivery-method-select');
          const locationSelect = document.getElementById('location-select');
          const stateSelect = document.getElementById('state-select');
          
          if (deliverySelect && deliverySelect.value) {
            const isPickup = deliverySelect.value.toLowerCase().includes('pickup');
            
            const propInputs = [
              { name: 'properties[Delivery Method]', value: deliverySelect.value },
              { name: 'properties[_delivery_type]', value: isPickup ? 'pickup' : 'shipping' }
            ];
            
            if (isPickup && locationSelect && locationSelect.value) {
              propInputs.push({ name: 'properties[Pickup Location]', value: locationSelect.value });
            } else if (!isPickup && stateSelect && stateSelect.value) {
              propInputs.push({ name: 'properties[State Delivery]', value: stateSelect.value });
            }
            
            propInputs.forEach(prop => {
              const input = document.createElement('input');
              input.type = 'hidden';
              input.name = prop.name;
              input.value = prop.value;
              productForm.appendChild(input);
              console.log(`Re-added: ${prop.name} = ${prop.value}`);
            });
          }
        }
      }
    }, true);
  }
}

// Initialize
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    window.variantSummary = new IntegratedVariantSummary();
    if (window.variantSummary && window.variantSummary.hasMultipleVariants) {
      setTimeout(setupAddToCartValidation, 500);
    }
  });
} else {
  window.variantSummary = new IntegratedVariantSummary();
  if (window.variantSummary && window.variantSummary.hasMultipleVariants) {
    setTimeout(setupAddToCartValidation, 500);
  }
}